import ButtonPrimary from "shared/Button/ButtonPrimary";
import React from "react";
import { Helmet } from "react-helmet";
import NcImage from "shared/NcImage/NcImage";
import I404Png from "images/404.png";

const Page404: React.FC = () => (
  <div className="nc-Page404">
    <Helmet>
      <title>BecauseYes | 404</title>
    </Helmet>
    <div className="container relative pt-5 pb-16 lg:pb-20 lg:pt-5">
      {/* HEADER */}
      <header className="text-center max-w-2xl mx-auto space-y-2">
        <NcImage src={I404Png} className="drop-shadow-2xl"/>
        <span className="block text-sm text-neutral-800 sm:text-lg dark:text-neutral-200 tracking-wider font-medium">
        Oops! I think this section is not available{" "}
        </span>
        <div className="pt-8">
          <ButtonPrimary href="/">Back home</ButtonPrimary>
        </div>
      </header>
    </div>
  </div>
);

export default Page404;
